import React from 'react';
import { HEADER_WIDTH, ROW_HEIGHT } from './constants';

type DragVisual = { startY: number; currentY: number } | null;
type SelectionMask = { leftWidth: number; rightLeft: number } | null;

type Props = {
  dragVisual: DragVisual;
  selectionMask: SelectionMask;
  dragBlocked: boolean;
  editMode: boolean;
  startTime?: string;
  endTime?: string;
};

const DragSelection: React.FC<Props> = ({ dragVisual, selectionMask, dragBlocked, editMode, startTime, endTime }) => {
  const remToPx = (rem: number): number => {
    const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return rem * fontSize;
  };
  
  const ROW_HEIGHT_PX = remToPx(ROW_HEIGHT);
  const HEADER_WIDTH_PX = remToPx(HEADER_WIDTH);
  
  return (
    <>
      {dragVisual && (
        <>
          <div style={{ position: 'absolute', left: 0, right: 0, top: Math.min(dragVisual.startY, dragVisual.currentY), height: 1, background: '#60a5fa', pointerEvents: 'none', zIndex: 5 }} />
          <div style={{ position: 'absolute', left: 0, right: 0, top: Math.max(dragVisual.startY, dragVisual.currentY), height: 1, background: '#6D57BC', pointerEvents: 'none', zIndex: 5 }} />
          <div
            style={{
              position: 'absolute',
              top: Math.min(dragVisual.startY, dragVisual.currentY) + 4,
              left: selectionMask ? (selectionMask.leftWidth + 6) : (HEADER_WIDTH_PX + 6),
              width: selectionMask ? Math.max(0, selectionMask.rightLeft - selectionMask.leftWidth - 12) : ('calc(100% - ' + (HEADER_WIDTH_PX + 12) + 'px)'),
              height: Math.max(ROW_HEIGHT_PX - 6, Math.abs(dragVisual.currentY - dragVisual.startY) - 6),
              background: dragBlocked ? 'rgba(156, 163, 175, 0.6)' : 'rgba(109, 87, 188, 0.24)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.875rem !important',
              fontWeight: 700,
              pointerEvents: 'none',
              zIndex: 6,
              borderRadius: 6
            }}
          >
            {editMode
              ? (startTime && endTime ? `${startTime} - ${endTime}` : 'Rango')
              : 'Sesión'}
          </div>
        </>
      )}
    </>
  );
};

export default DragSelection;


